// <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="lucide lucide-pool-sb">
// <circle cx="12" cy="12" r="10"/>
// <path d="
// M10,9L 6,12L10,15
// M14,9L18,12L14,15"/>
// </svg>

import { LucideIconData } from 'lucide-angular';

export const PoolSoftware: LucideIconData = [
  [
    'circle',
    {
      cx: '12',
      cy: '12',
      r: '10',
    },
  ],
  [
    'path',
    {
      d: 'M10,9L6,12L10,15M14,9L18,12L14,15',
    },
  ],
];
